export default {
  sections: {
    asap_orders: {
      title: 'Directe bestellingen',
      fields: {
        has_live_orders: {
          label: 'Live bestellingen',
          tooltip:
            'Schakel dit alleen in wanneer het restaurant daadwerkelijk live gaat en bestellingen begint te accepteren',
        },
        has_asap_orders: {
          label: 'Kunnen klanten directe bestellingen plaatsen?',
          tooltip: '*Directe bestellingen zijn gebaseerd op uw bereidingstijd',
        },
      },
    },
    scheduled_orders: {
      title: 'Geplande bestellingen',
      fields: {
        has_scheduled_orders: {
          label: 'Kunnen klanten vooruitbestellen voor een bepaalde tijd?',
        },
        has_pre_order: {
          label: 'Kunnen klanten meer dan één dag vooruit bestellen?',
        },
        max_pre_order_days: {
          label: 'Maximum aantal dagen vooruit bestellen',
          placeholder: '14',
        },
        has_scheduled_order_reminders: {
          label: 'Herinneringsmeldingen geplande bestellingen',
        },
        scheduled_orders_time_slot_interval: {
          label: 'Tijdvakken in minuten',
          option: '{{value}} minuten tijdvak',
        },
        has_scheduled_orders_time_slot_order_limit: {
          label: 'Maximum aantal bestellingen per tijdvak toevoegen',
        },
        scheduled_orders_time_slot_order_limit: {
          label: 'Maximum aantal bestellingen per tijdvak',
          placeholder: '5',
        },
        scheduled_order_option_title: {
          label: 'Optietitel voor later inplannen',
          placeholder: 'Later inplannen',
        },
      },
    },
    other: {
      title: 'Overig',
      fields: {
        order_approval_time_step: {
          label: 'Bevestigde besteltijd verhogen / verlagen',
          option: '{{value}} min',
        },
        order_confirmation_time_extra_minutes: {
          label: 'Extra minuten toevoegen aan bevestigde tijd',
          option: '{{value}} min',
        },
      },
    },
  },
  buttons: {
    save: 'Opslaan',
  },
  feedback: {
    restaurant_suspended: {
      title: 'Dit restaurant is opgeschort',
      description:
        'Om weer live te gaan, navigeer naar de <a>abonnementspagina</a> en activeer het restaurant opnieuw. Daarna kunt u live bestellingen op deze pagina inschakelen.',
    },
  },
  toasts: {
    at_least_one_order_method_required:
      'Minimaal 1 bestelmethode (gepland of direct) moet ingeschakeld zijn. Je kunt niet beide uitschakelen.',
  },
};
